import React from "react";
import ScoreBoard from "./ScoreBoard";
const App = () => (
  <div className="App">
    <ScoreBoard />
  </div>
);
export default App;
